// extracted by mini-css-extract-plugin
export default {"breakdownWidth":"500","maxWidth":"200","container":"OrganizationLogo_container__9Mrfh","logo":"OrganizationLogo_logo__xQDjo"};